import React from "react";
import { Route, IndexRedirect } from "react-router";

import {SessionStore} from "./services/Session";
import Auth from "./pages/Auth";
import Login from "./pages/Login";
import {NotAuthorizedException, NotFoundException} from "./Exceptions";
import Main from "./pages/Main";
import Resource from "./pages/Resource";
import Forgot from "./pages/Forgot";


function pathMatches(nextState, path) {
    var pathWithoutQuery = path.split('?', 2);
    var pathItems = pathWithoutQuery[0].split('/');

    if (nextState.routes.length !== pathItems.length) return false;
    for (var i = 1; i < pathItems.length; i++) {
        if (nextState.routes[i].path !== pathItems[i]) return false;
    }
    return true;
}

function replacePath(nextState, replace, path) {
    if (!pathMatches(nextState, path)) {
        replace({pathname: path, state: {redirect: nextState.location.pathname}});
        return true;
    }
    return false;
}

function verifyAuthenticated(nextState, replace) {
    if (!SessionStore.isAuthenticated()) return replacePath(nextState, replace, '/login');
    return false;
}

function verifyAuthorized(nextState, replace) {
    if (!SessionStore.isAuthorized(nextState.location.pathname)) throw new NotAuthorizedException();
    return false;
}

function requireAuth(nextState, replace) {
    if (verifyAuthenticated(nextState, replace)) return;
    // if (verifyAuthorized(nextState, replace)) return;
}

const RouteNotFound = (props) => {
    throw new NotFoundException();
};

let Routes = (
    <Route path="/">
        <IndexRedirect to="ui"/>

        <Route path="auth" component={Auth} />
        <Route path="login" component={Login} />
        <Route path="forgot/:authToken" component={Forgot} />

        <Route path="ui" component={Main} onEnter={requireAuth}>
            <Route path=":resource" component={Resource} />
            <Route path=":resource/**" component={Resource} />
        </Route>
        <Route path="*" component={RouteNotFound} />
    </Route>
);

export default Routes;
